/**
 * @generated SignedSource<<43a7972957753be1c6e6e2b5d2fecd17>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RemoveAsanaProjectInput = {
  clientMutationId?: string | null;
};
export type AsanaRemoveProjectModalMutation$variables = {
  input: RemoveAsanaProjectInput;
};
export type AsanaRemoveProjectModalMutation$data = {
  readonly removeAsanaProject: {
    readonly ok: boolean;
  } | null;
};
export type AsanaRemoveProjectModalMutation = {
  response: AsanaRemoveProjectModalMutation$data;
  variables: AsanaRemoveProjectModalMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RemoveAsanaProjectPayload",
    "kind": "LinkedField",
    "name": "removeAsanaProject",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AsanaRemoveProjectModalMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AsanaRemoveProjectModalMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0faf85ce11be1ccc88270d1dc9de4491",
    "id": null,
    "metadata": {},
    "name": "AsanaRemoveProjectModalMutation",
    "operationKind": "mutation",
    "text": "mutation AsanaRemoveProjectModalMutation(\n  $input: RemoveAsanaProjectInput!\n) {\n  removeAsanaProject(input: $input) {\n    ok\n  }\n}\n"
  }
};
})();

(node as any).hash = "9f869fa4a9bf58ce71914aec7d1947ae";

export default node;
